import styled from 'styled-components';
import { cssVar } from 'styles/helper';

export const PositionContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background-color: ${cssVar('bg-primary')};
  display: flex;
  flex-direction: column;
`;

export const RelativeContainer = styled.div`
  position: relative;
  backface-visibility: hidden;
  transition: height 0.3s ease-in-out;
  height: var(--header-height, 80px);
`;
